import * as React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CloseHeavyRegular from './close-heavy-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CloseHeavyRegular {...validProps} />;
}
SvgComponent.iconName = 'closeHeavyRegular';

export const CloseHeavyRegularIcon = svgIconWrapper(SvgComponent);
